/**
 * @file
 * @version 42
 * @description This is the Marina chatbot Phase 2 frontend script for Corp.
 * @date 2025-04-08 11am
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app.jsx";
import "/content/dam/hlb/my/chatbot/fonts/font-awesome.min.css";
import "/content/dam/hlb/my/chatbot/fonts/noto-sans.css";
import store from "./app/store.js";
import { Provider } from "react-redux";

var host = document.createElement("div");
host.id = "app";
document.body.appendChild(host);

const shadowRoot = host.attachShadow({ mode: "open" });

ReactDOM.createRoot(shadowRoot).render(
    <React.StrictMode>
        <Provider store={ store }>
            <App/>
        </Provider>
    </React.StrictMode>
);
